module.exports = __webpack_public_path__ + "static/media/3.31e8988f.jpg";